<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester date keyword="學號">
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年-學期</th>
                            <th>學號-姓名</th>
                            <th>日期</th>
                            <th>下載</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.InjuryHandleID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.InjuryHandleID" /></td>
                        <td data-th="學年-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="學號-姓名"><b-button size="sm" variant="link" @click="edit(item.InjuryHandleID)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                        <td data-th="日期">{{item.Date|date('yyyy/mm/dd')}}</td>
                        <td data-th="下載"><div class="btn btn-info" @click="download(item.InjuryHandleID)">下載</div></td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
            <template slot="place">
                <div is="option" v-for="o in places" :key="o.key" :value="o.key">{{o.value}}</div>
            </template>
        </Detail>
    </page-main>
</template>

<script>
    import Detail from './injuryhandleDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'injuryhandle',
        api: '/api/injuryhandle/',
        components: { Detail },
        data: { places: [] },
        created: function () {
            this.$parameter.injuryplaces().then((res) => { this.places = res.data; });
        },
        methods: {
            download: function (id) {
                window.open(this.$apiurl + 'api/injuryhandle/Download/' + id)
            },
        }
    });
</script>

<style>
</style>